// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "./adminlte";
import "./overlayscrollbars_init";
import "./sortable_init";
import "./jsvectormap_init";

// features
import "./service_order_items";

// CHARTS
// import "./apexcharts_init";
import "./dashboard_revenue_chart";
import "./expenses_chart";
import "./sales_chart";
import "./sales_expenses_chart"

